import { svgToIcon } from '../utils/svg';
import Stylus from './Stylus';
import TableDrawingBrush from './TableDrawingBrush';
import table from '../assets/icons/table.svg';
import styles from '../styles.module.css';
import { labeledMenuComponent } from '../utils/stylus';

// Create new frame objects.
class StylusTable extends Stylus {
  constructor({ controller }) {
    super({ controller });
  }

  stylusId() {
    return 'table';
  }

  activate() {
    const brush = new TableDrawingBrush(this.controller.canvas, this);
    this.controller.canvas.isDrawingMode = true;
    this.controller.canvas.freeDrawingBrush = brush;
  }

  renderIcon() {
    return svgToIcon(table);
  }

  toolButtonClass() {
    return styles.labeledToolButton;
  }

  menuComponent() {
    return labeledMenuComponent(this.renderIcon(), this.description());
  }

  cursor() {
    return 'crosshair';
  }

  description() {
    return 'Table';
  }
}

export default StylusTable;
